<template>
 <!-- 现有的逻辑只是针对属性 -->

     <el-form ref="ruleForm"  :rules="rules" :model="condition">
      <el-row type="flex">
        <el-form-item label="" prop="key">
          <el-select
          :disabled="disabled"
          @change="selChange"
          v-model="condition.key"
          :placeholder="typeText">
              <el-option
                v-for="(item,index) in condition.modelData"
                :key="index"
                :label="item.name"
                :value="item.identifier">
              </el-option>
            </el-select>
        </el-form-item>

    <!-- 第一select框选中之后 -->
    <!-- 有outputData就一定有子选项（事件或者服务） -->
    <template v-if="currentModel && !condition.modelData.outputData">
        <template v-if="['int','double','float','bool','enum','text','date'].indexOf(currentModel.dataType.type) >= 0 ||
            (['array'].indexOf(currentModel.dataType.type) >= 0 && ['int','double','float','text'].indexOf(currentModel.dataType.specs.item.type) >= 0)">
            <el-form-item label="" prop="term">
              <el-select
              :disabled="disabled"
              class="mal10"
                v-model="condition.term"
                placeholder="请选择">
                <el-option
                  v-for="item in compareList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- bool\enum不一样，用来选择 -->
            <template  v-if="['bool','enum'].indexOf(currentModel.dataType.type) >= 0">
              <el-form-item
                label=""
                prop="fieldValue">
                <el-select
                :disabled="disabled"
                class="mal10"
                  v-model="condition.fieldValue"
                  placeholder="请选择">
                    <el-option
                      v-for="key in Object.keys(currentModel.dataType.specs)"
                      :key="key"
                      :label="currentModel.dataType.specs[key]"
                      :value="key">
                    </el-option>
                </el-select>
              </el-form-item>
            </template>
            <!-- 其他类型都是输入值 -->
            <template v-else>
              <el-form-item label="" prop="fieldValue">
                <el-input
                @blur="formatValue"
                :disabled="disabled"
                class="mal10"
                  v-model="condition.fieldValue"
                  placeholder="请输入数值"></el-input>
            </el-form-item>
            </template>

        </template>

      <!-- 选中的item分各种情况 -->
      <!-- 数值类型 -->
      <!-- <template  v-if="['int','double','float'].indexOf(currentModel.dataType.type) >= 0">
         <el-form-item label="" prop="term">
          <el-select
          :disabled="disabled"
           class="mal10"
            v-model="condition.term"
            placeholder="请选择">
            <el-option
              v-for="item in compareList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
         </el-form-item>
          <el-form-item label="" prop="fieldValue">
              <el-input
              :disabled="disabled"
              class="mal10"
                v-model="condition.fieldValue"
                placeholder="请输入数值"></el-input>
          </el-form-item>
      </template> -->

      <!-- bool类型, enum枚举类型-->
      <!-- 选择对应的选项即可，不需要去输入值去比对 -->
       <!-- <el-form-item
        v-else-if="['bool','enum'].indexOf(currentModel.dataType.type) >= 0"
        label=""
        prop="fieldValue">
        <el-select
        :disabled="disabled"
        class="mal10"
          v-model="condition.fieldValue"
          placeholder="请选择">
             <el-option
              v-for="key in Object.keys(currentModel.dataType.specs)"
              :key="key"
              :label="currentModel.dataType.specs[key]"
              :value="key">
            </el-option>
        </el-select>
       </el-form-item> -->

       <!-- text类型-->
       <!-- <template v-else-if="['text'].indexOf(currentModel.dataType.type) >= 0">
          <el-form-item label="" prop="fieldValue">
              <el-input
              :disabled="disabled"
               class="mal10"
                v-model="condition.fieldValue"
                placeholder="请输入数值"></el-input>
          </el-form-item>
       </template> -->
       <!-- date类型-->
       <!-- <template v-else-if="['date'].indexOf(currentModel.dataType.type) >= 0">

          <el-form-item label="" prop="fieldValue">
            <el-input
            :disabled="disabled"
            class="mal10"
              v-model="condition.fieldValue"
              placeholder="请输入数值"></el-input>
          </el-form-item>
       </template> -->

      <!-- array类型-->
      <!-- <template
          v-else-if="['array'].indexOf(currentModel.dataType.type) >= 0 && ['int','double','float','text'].indexOf(currentModel.dataType.specs.item.type) >= 0">
            <el-form-item label="" prop="fieldValue">
                <el-input
                :disabled="disabled"
                class="mal10"
                  v-model="condition.fieldValue"
                  placeholder="请输入数值"></el-input>
            </el-form-item>
        </template> -->

    </template>

    <!-- 是否有子选项（类型是Arry和Struct的情况下） -->
    <div
      :span="3"
      class=""
      v-if="showAddBtn">
        <span
        class="el-icon-plus addBtn"
        @click.stop="addSubFilter">筛选条件</span>
    </div>

    <div
      class="mal10"
      :span="2"
      @click="delTtem">
        <span class="el-icon-error" style="margin-top:15px;margin-left:10px"></span>
    </div>
    </el-row>
  </el-form>

</template>
<script>
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    thingModelType: {
      type: String
    },
    condition: {
      type: Object
    },
    operate: {
      type: String
    }
  },
  created () {
    eventBus.$on('filterValidate', this.validate)
    if (this.condition.currentModel) {
      // 将数值类型转化为string
      Object.keys(this.condition).forEach(key => {
        if (!isNaN(this.condition[key])) {
          this.condition[key] = this.condition[key].toString()
        }
      })
      this.currentModel = this.condition.currentModel
    }
  },
  data () {
    var validateFieldValue = (rule, value, callback) => {
      this.condition.fieldValue = this.condition.fieldValue.trim()
      // console.log(parseFloat(this.condition.fieldValue), parseFloat(this.currentModel.dataType.specs.min), parseFloat(this.currentModel.dataType.specs.max))

      if (['enum', 'bool'].indexOf(this.currentModel.dataType.type) >= 0) {
        if (this.condition.fieldValue === '') {
          callback(new Error('请选择'))
        } else {
          callback()
        }
      } else if (['int', 'double', 'float'].indexOf(this.currentModel.dataType.type) >= 0) { // 数值类型
        if (isNaN(this.condition.fieldValue)) {
          callback(new Error('请输入数值'))
        } else if (
          (parseFloat(this.condition.fieldValue) < parseFloat(this.currentModel.dataType.specs.min) || parseFloat(this.condition.fieldValue) > parseFloat(this.currentModel.dataType.specs.max))
        ) {
          callback(new Error(`输入的数值必须介于${this.currentModel.dataType.specs.min}~${this.currentModel.dataType.specs.max}之间`))
        } else if (this.condition.fieldValue === '') {
          callback(new Error('请输入数值'))
        } else {
          callback()
        }
      } else if (this.condition.fieldValue === '') { // 剩下的其他类型输入框也不能为空
        callback(new Error('请输入数值'))
      } else {
        callback()
      }
    }
    return {
      showAddBtn: false, // 用于显示是否可以添加子项目的的添加按钮
      subModelData: [], // 保存子菜单的物模型数据
      currentModel: '', // 当前选中的选项
      compareList: [
        { label: '等于', value: '1' },
        { label: '不等于', value: '2' },
        { label: '小于', value: '3' },
        { label: '大于', value: '4' },
        { label: '小于或等于', value: '5' },
        { label: '大于或等于', value: '6' },
        { label: '包含', value: '7' },
        { label: '不包含', value: '8' }
      ],
      form: {
        fieldValue: ''
      },
      rules: {
        fieldValue: [
          { validator: validateFieldValue, trigger: 'change' }
        ],
        key: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        term: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      },
      disabled: this.operate === 'detail'
    }
  },
  methods: {
    formatValue () {
      this.condition.fieldValue = this.condition.fieldValue.trim()
      if (this.condition.fieldValue !== '' && !isNaN(this.condition.fieldValue)) {
        // this.condition.fieldValue = parseFloat(this.condition.fieldValue).toFixed(2)
        if (['double', 'float'].indexOf(this.currentModel.dataType.type) >= 0) { // double，float类型单独做下处理
          console.log('this.condition:', this.condition)
          let fixedNum = 2 // 默认精确的小数点位为两位
          // 根据最大、最小值获取精确的小数点位
          const maxArr = this.currentModel.dataType.specs.max.toString().split('.')
          const minArr = this.currentModel.dataType.specs.min.toString().split('.')
          const maxNum = maxArr[1] ? maxArr[1].toString().length : fixedNum
          const minNum = minArr[1] ? minArr[1].toString().length : fixedNum
          if (maxNum > minNum) {
            fixedNum = maxNum
          } else {
            fixedNum = minNum
          }
          this.condition.fieldValue = parseFloat(this.condition.fieldValue).toFixed(fixedNum)
        }
      }
      console.log(778899)
    },
    validate () {
      if (this.$refs.ruleForm && this.$refs.ruleForm.validate) {
        this.$refs.ruleForm.validate((valid) => {
          console.log('子组件验证valid88：', valid)
          this.condition.validate = valid
          console.log('子组件验证condition：', this.condition)
          // fieldType 2 字符串 1 数值 3 浮点类型（double、float）
          if (valid) {
            if (['double', 'float'].indexOf(this.currentModel.dataType.type) >= 0) {
              this.condition.fieldType = 3
            } else if (isNaN(this.condition.term)) {
              this.condition.fieldType = 2
            } else {
              this.condition.fieldType = 1
            }
          }
        })
      }
    },
    addSubFilter () {
      if (this.operate === 'detail') {
        return
      }
      // 添加子筛选条件
      const child = {
        field: '', // 对应属性标识符
        term: '', // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
        fieldValue: '', // 对应属性值
        fieldType: '', // 1数字 2字符串
        fieldName: '', // 属性名称
        children: [], // 是否有子节点，界面展示需要，不用传递到后台
        id: Date.parse(new Date()) + Math.random(), // 作为树的唯一标示
        modelData: this.subModelData, // 把对应的物模型数据带过去
        validate: true // 验证默认是通过的
      }
      this.condition.children.push(child)
    },
    selChange (val) {
      if (this.operate === 'detail') {
        return
      }
      console.log('val:', val)
      this.currentModel = ''
      // 清空重置子菜单
      this.showAddBtn = false
      this.subModelData = []
      // 其他数据做还原
      this.condition.children.splice(0, this.condition.children.length)
      Object.assign(this.condition, {
        field: '', // 对应属性标识符
        term: '', // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
        fieldValue: '', // 对应属性值
        fieldType: '', // 1数字 2字符串
        fieldName: '' // 属性名称
      })
      // 循环查出所在项的整个对象
      let i = 0
      const modelData = this.condition.modelData
      while (i < modelData.length) {
        const item = modelData[i]
        if (item.identifier === val) {
          this.currentModel = item.outputData ? null : item
          this.condition.field = item.identifier
          this.condition.fieldName = item.name
          // 暂时默认数值就为数字，其他为字符串
          // if (item.dataType.type === 'number') {
          //   this.condition.fieldType = 1
          // } else {
          //   this.condition.fieldType = 2
          // }
          // 重新比对，把选中的对应的项筛选出来
          // 是否有子选项
          // struct类型

          // v-else-if="['array'].indexOf(currentModel.dataType.type) >= 0 && ['int','double','float','text'].indexOf(currentModel.dataType.specs.item.type) >= 0"
          if (item.outputData) { // 事件和服务就是一定有子选项的
            this.showAddBtn = true
            this.subModelData = item.outputData
            console.log('事件进入this.subModelData：', this.subModelData)
          } else if (item.dataType.type === 'struct' && item.dataType.specs.length > 0) {
            this.showAddBtn = true
            this.subModelData = item.dataType.specs
          } else if (
            item.dataType.type === 'array' &&
              item.dataType.specs.item.type === 'struct' &&
              item.dataType.specs.item.specs.length > 0) {
            // 数组类型
            this.showAddBtn = true
            this.subModelData = item.dataType.specs.item.specs
          }
          console.log('找到的物理模型item:', item)
          break
        }
        i++
      }
    },
    delTtem () {
      if (this.operate === 'detail') {
        return
      }
      console.log(7777)
      this.$emit('delNode', this.condition)
    }
  },
  computed: {
    typeText () {
      const textType = {
        properties: '属性',
        events: '事件',
        services: '服务'
      }
      return '请选择' + textType[this.thingModelType]
    }
  }
}
</script>
<style lang="less" scope>
.alignCenter{
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.mal10{
  margin-left: 10px;
}
.addBtn{
  margin-left: 10px;
  margin-top: 15px;
}
</style>
